import React, { FC } from 'react';

import { FieldArray, useFormikContext } from 'formik';

import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';

import {
    NotificationButtonElement,
    NotificationButtonFormValues,
} from '../../../../../../models/formula.model';

import AndroidButtonFields from './AndroidButtonFields';
import AndroidFieldAddNewButton from './AndroidFieldAddNewButton';
import FieldToggle from './FieldToggle';

const AndroidButtonForm: FC = () => {
    const { setFieldValue, values, errors } =
        useFormikContext<NotificationButtonFormValues>();

    const { androidToggle, androidButtons } = values;

    return (
        <Container>
            <FieldToggle
                isActive={androidToggle}
                platform="Android"
                fieldKey="androidToggle"
                setFieldValue={setFieldValue}
            />

            <TitleContent>
                <Title isBold>Button behavior </Title>
                <Description>
                    Set click behavior for each button (max. 3 buttons)
                </Description>
            </TitleContent>

            <FieldArray
                name="androidButtons"
                render={({ remove }) => (
                    <Content>
                        {androidButtons?.map(
                            (
                                button: NotificationButtonElement,
                                index: number,
                            ) => (
                                <AndroidButtonFields
                                    key={index}
                                    index={index}
                                    valLength={androidButtons?.length}
                                    errors={errors?.androidButtons as any}
                                    fieldPrefixKey={`androidButtons[${index}]`}
                                    value={button}
                                    remove={remove}
                                    isDisabled={!androidToggle}
                                />
                            ),
                        )}
                    </Content>
                )}
            />
            <AndroidFieldAddNewButton />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
    minHeight: '200px',
});

const Title = styled.div<{ isBold?: boolean }>(({ isBold }) => ({
    fontSize: aampeTheme.size.font.default,
    fontWeight: isBold ? aampeTheme.weights.medium : aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.neutral09,
}));

const Description = styled.div({
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.textAccessibleWG01,
});

const Content = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
    maxHeight: '300px',
    overflowY: 'auto',
});

const TitleContent = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});

export default AndroidButtonForm;
